import {
  DEFAULT_AUTH,
  LOGIN_ERROR,
  LOGIN_LAWYER,
  LOGIN_SUCCESS,
  LOGOUT,
  REFRESH_SUCCESS
} from './constants'
import { LogoutReason } from './models'

export default class AuthAction {
  static login({ email, password }) {
    return {
      type: LOGIN_LAWYER,
      payload: {
        sending: true
      },
      meta: {
        email,
        password
      }
    }
  }

  static onLoginSuccess({
    token,
    refreshToken,
    id,
    role
  }: {
    token: string
    refreshToken?: string
    id: number | string
    role: string
  }) {
    return {
      type: LOGIN_SUCCESS,
      payload: {
        token,
        refreshToken,
        id,
        role,
        sending: false
      }
    }
  }

  static onRefreshSuccess({ token, refreshToken }: { token: string; refreshToken?: string }) {
    return {
      type: REFRESH_SUCCESS,
      payload: {
        token,
        refreshToken
      }
    }
  }

  static onLoginError(e) {
    return {
      type: LOGIN_ERROR,
      payload: {
        sending: false,
        loginError: e
      }
    }
  }

  static logout(reason?: LogoutReason) {
    return {
      type: LOGOUT,
      payload: { reason }
    }
  }

  static setDefaultStore() {
    return {
      type: DEFAULT_AUTH
    }
  }
}
